import SVG from 'react-inlinesvg';
import { ReactComponent as MedicalLogo } from '../../../assets/svg/vr-medical-logo.svg';
import { ReactComponent as ResqueLogo } from '../../../assets/svg/vr-resque-logo.svg';
import { ReactComponent as SchoolLogo } from '../../../assets/svg/vr-school-logo.svg';
import { ReactComponent as TrainingLogo } from '../../../assets/svg/vr-training-logo.svg';
import { isRescue, isSchool, isTraining } from '../../../lib/useAppVariant';
import useCompany from '../../../lib/useCompany';

interface Props {
  className?: string;
  color?: string;
}

const StreamLogo = (props: Props) => {
  const { company } = useCompany();
  if (company?.logoUrl) {
    return <SVG src={company.logoUrl} {...props} />;
  }
  if (isRescue()) {
    return <ResqueLogo {...props} />;
  }
  if (isTraining()) {
    return <TrainingLogo {...props} />;
  }
  if (isSchool()) {
    return <SchoolLogo {...props} />;
  }

  return <MedicalLogo {...props} />;
};

export default StreamLogo;
